export default __webpack_public_path__ + "static/media/crachá-horizontal.92f43cf8.png";